var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { staticClass: "welcome" },
            [
              !_vm.$wf.isSmDown
                ? _c(
                    "w-col",
                    { attrs: { grow: "", md: "6", xl: "6", xs: "12" } },
                    [
                      _c("h1", [
                        _vm._v(
                          _vm._s(_vm.welcomMsg) + " " + _vm._s(_vm.firstName)
                        ),
                      ]),
                      _c("p", [_vm._v(_vm._s(_vm.$ct("start.overview")))]),
                    ]
                  )
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { grow: "", md: "6", xl: "6", xs: "12" } },
                [_c("tiny-account-info")],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { staticClass: "discover", style: { marginTop: "20px" } },
            [
              _c(
                "w-col",
                { attrs: { md: "6", sm: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "12", sm: "12" } },
                                [
                                  _c("div", { staticClass: "progress-title" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct("start.progress-title")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "progress-sub-title" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.progressTitle) + " "
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "progress" }, [
                                    _c("div", {
                                      staticClass: "bar",
                                      style: { width: _vm.step * 25 + "%" },
                                    }),
                                  ]),
                                  _c(
                                    "w-list",
                                    { staticClass: "step-list" },
                                    [
                                      _c(
                                        "w-list-item",
                                        [
                                          _c(
                                            "w-list-item-text",
                                            { class: { ok: _vm.step > 0 } },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "check-circle" },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "step" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("start.steps.1")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-list-item",
                                        [
                                          _c(
                                            "w-list-item-text",
                                            {
                                              class: {
                                                ok: _vm.contactCreated,
                                                next: !_vm.contactCreated,
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "check-circle" },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "step" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("start.steps.2")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              !_vm.contactCreated
                                                ? _c(
                                                    "w-button",
                                                    {
                                                      staticClass: "start",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openContactCreateModal()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$ct("start.go")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-list-item",
                                        [
                                          _c(
                                            "w-list-item-text",
                                            {
                                              class: {
                                                ok: _vm.invoiceCreated,
                                                next:
                                                  _vm.contactCreated &&
                                                  !_vm.invoiceCreated,
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "check-circle" },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "step" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("start.steps.3")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm.contactCreated &&
                                              !_vm.invoiceCreated
                                                ? _c(
                                                    "w-button",
                                                    {
                                                      staticClass: "start",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openSaleCreateModal()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$ct("start.go")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.contactCreated &&
                                          !_vm.invoiceCreated
                                            ? _c(
                                                "div",
                                                { staticClass: "info-box" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct(
                                                        "start.info.invoice"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-list-item",
                                        [
                                          _c(
                                            "w-list-item-text",
                                            {
                                              class: {
                                                ok: _vm.productCreated,
                                                next: _vm.step === 3,
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "check-circle" },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "step" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("start.steps.4")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm.step === 3 &&
                                              _vm.invoiceCreated
                                                ? _c(
                                                    "w-button",
                                                    {
                                                      staticClass: "start",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openProductCreateModal()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$ct("start.go")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                [
                                  _c("w-checkbox", {
                                    staticClass: "mls",
                                    attrs: {
                                      value: _vm.showQuickStart,
                                      label: _vm.$ct("show-on-startup"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.toggleQuickStart()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "6", sm: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-content", [
                        _c("div", { staticClass: "progress-title" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("start.contact-title")) + " "
                          ),
                        ]),
                        _c("div", { staticClass: "progress-sub-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$ct("start.contact-sub-title")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "contact-info-box" }, [
                          _c("div", [
                            _c("img", {
                              attrs: {
                                alt: "caroline",
                                src: require("@/assets/img/caroline.png"),
                              },
                            }),
                          ]),
                          _c(
                            "div",
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("start.contact-1")) + " "
                              ),
                              _c(
                                "w-link",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.toggleDemoShedule = true
                                    },
                                  },
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("start.contact-2"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(
                                " " + _vm._s(_vm.$ct("start.contact-3")) + " "
                              ),
                              _c(
                                "b",
                                [
                                  _c(
                                    "w-link",
                                    { attrs: { href: "tel:+3214322322" } },
                                    [_vm._v("014/322.322")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { sm: "12" } }, [
                _c("h2", [_vm._v(_vm._s(_vm.$ct("start.discover")))]),
              ]),
            ],
            1
          ),
          _c(
            "w-row",
            { staticClass: "discover-more" },
            [
              _c(
                "w-col",
                { attrs: { md: "4", sm: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-title",
                        [
                          _c("w-fa", {
                            attrs: { icon: ["far", "envelope"], size: "2x" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-card-content",
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$ct("start.discover-more.1.title"))
                            ),
                          ]),
                          _c("span", { staticClass: "sub" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("start.discover-more.1.sub")) +
                                " "
                            ),
                          ]),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  ;(_vm.videoId = 749132962), (_vm.play = true)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("start.start-video")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "4", sm: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-title",
                        [
                          _c("w-fa", {
                            attrs: { icon: ["far", "user"], size: "2x" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-card-content",
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$ct("start.discover-more.2.title"))
                            ),
                          ]),
                          _c("span", { staticClass: "sub" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("start.discover-more.2.sub")) +
                                " "
                            ),
                          ]),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  ;(_vm.videoId = 747652656), (_vm.play = true)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("start.start-video")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "4", sm: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c(
                        "w-card-title",
                        [
                          _c("w-fa", {
                            attrs: { icon: ["fas", "euro-sign"], size: "2x" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-card-content",
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$ct("start.discover-more.3.title"))
                            ),
                          ]),
                          _c("span", { staticClass: "sub" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("start.discover-more.3.sub")) +
                                " "
                            ),
                          ]),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  ;(_vm.videoId = 749137215), (_vm.play = true)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("start.start-video")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.play,
                callback: function ($$v) {
                  _vm.play = $$v
                },
                expression: "play",
              },
            },
            [
              _c(
                "w-card",
                { staticClass: "video-wrapper", style: { width: "auto" } },
                [
                  _c(
                    "w-card-title",
                    [
                      _c("w-spacer"),
                      _c("w-fa", {
                        staticClass: "mts mrs",
                        attrs: { icon: "times" },
                        on: {
                          click: function ($event) {
                            _vm.play = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-content",
                    { staticClass: "video-box", style: { padding: "0 0 0 0" } },
                    [_c("player", { attrs: { id: _vm.videoId } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              attrs: { "escape-close": "" },
              model: {
                value: _vm.contactCreateModal,
                callback: function ($$v) {
                  _vm.contactCreateModal = $$v
                },
                expression: "contactCreateModal",
              },
            },
            [
              _vm.contactCreateModal
                ? _c(
                    "w-card",
                    { style: { maxWidth: "100%" } },
                    [
                      _c(
                        "w-card-title",
                        { staticClass: "blue" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$ct("start.titles.contact-create")) +
                              " "
                          ),
                          _c("w-spacer"),
                          _c("w-fa", {
                            staticClass: "mts mrs",
                            attrs: { icon: "times" },
                            on: {
                              click: function ($event) {
                                _vm.contactCreateModal = false
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { style: { height: "calc(100vh - 56px)" } },
                        [
                          _c("app-create-contact", {
                            attrs: { "drawer-button-disabled": "" },
                            on: {
                              cancel: function ($event) {
                                _vm.contactCreateModal = false
                              },
                              save: function ($event) {
                                _vm.validateProgress(),
                                  (_vm.contactCreateModal = false)
                              },
                            },
                            model: {
                              value: _vm.newContact,
                              callback: function ($$v) {
                                _vm.newContact = $$v
                              },
                              expression: "newContact",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              staticClass: "w100",
              style: { height: "100%;" },
              attrs: { "escape-close": "" },
              model: {
                value: _vm.saleCreateModal,
                callback: function ($$v) {
                  _vm.saleCreateModal = $$v
                },
                expression: "saleCreateModal",
              },
            },
            [
              _c(
                "w-card",
                { style: { maxWidth: "100%" } },
                [
                  _c(
                    "w-card-title",
                    { staticClass: "blue" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("start.titles.sale-create")) + " "
                      ),
                      _c("w-spacer"),
                      _c("w-fa", {
                        staticClass: "mts mrs",
                        attrs: { icon: "times" },
                        on: {
                          click: function ($event) {
                            _vm.saleCreateModal = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { style: { height: "calc(100vh - 56px)" } },
                    [
                      _c("app-sale-edit", {
                        attrs: {
                          value: _vm.newSale,
                          "prevent-redirect": "",
                          "contact-group-id": 1,
                        },
                        on: {
                          close: function ($event) {
                            _vm.saleCreateModal = false
                          },
                          input: function ($event) {
                            return _vm.validateProgress()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              staticClass: "w100",
              style: { height: "100%;" },
              attrs: { "escape-close": "" },
              model: {
                value: _vm.productCreateModal,
                callback: function ($$v) {
                  _vm.productCreateModal = $$v
                },
                expression: "productCreateModal",
              },
            },
            [
              _c(
                "w-card",
                { style: { maxWidth: "100%" } },
                [
                  _c(
                    "w-card-title",
                    { staticClass: "blue" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$ct("start.titles.product-create")) +
                          " "
                      ),
                      _c("w-spacer"),
                      _c("w-fa", {
                        staticClass: "mts mrs",
                        attrs: { icon: "times" },
                        on: {
                          click: function ($event) {
                            _vm.productCreateModal = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { style: { height: "calc(100vh - 56px)" } },
                    [
                      _c("app-edit-product", {
                        ref: "AppEditProduct",
                        attrs: {
                          value: _vm.newProduct,
                          "show-edit-composition": "",
                          "drawer-button-disabled": "",
                        },
                        on: {
                          cancel: function ($event) {
                            _vm.productCreateModal = false
                          },
                          saved: function ($event) {
                            _vm.validateProgress(),
                              (_vm.productCreateModal = false)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              attrs: { "escape-close": "" },
              model: {
                value: _vm.toggleDemoShedule,
                callback: function ($$v) {
                  _vm.toggleDemoShedule = $$v
                },
                expression: "toggleDemoShedule",
              },
            },
            [
              _c("app-demo-shedule", {
                on: {
                  cancel: function ($event) {
                    _vm.toggleDemoShedule = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }